module.exports = __webpack_public_path__ + "static/media/zeppelin.e34d1ddf.svg";